export const openPlatformQueryKeys = {
  usageSummary: ['open-platform', 'usage-summary'],
  clients: ['open-platform', 'clients'],
  webhooks: ['open-platform', 'webhooks'],
  deliveries: (webhookId = 'all') => ['open-platform', 'deliveries', webhookId],
  integrations: ['open-platform', 'integrations'],
};
